import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Folder, Identifiable } from "@planzone/dto";
import { useMoveFolder } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { FolderSelection } from "./folderSelection";
import { Props } from "./types";
import styles from "./styles.scss";

function MoveFolder({ folder, namespace, projectName, type, close }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, isRequestSuccess, isRequestFailure, moveFolder } =
    useMoveFolder();
  const [selectedFolder, setSelectedFolder] =
    useState<Identifiable<Folder> | null>(null);

  return (
    <Modal
      header={t("moveFolder.title")}
      headerClassName={styles.header}
      close={close}
    >
      <div className={styles.main}>
        <div className={styles.body}>
          <FolderSelection
            namespace={namespace}
            type={type}
            selectedFolder={selectedFolder}
            placeholder={t("moveFolder.placeholder")}
            projectName={projectName}
            sourceFolder={folder}
            select={(folder) => setSelectedFolder(folder)}
          />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={close}>
            {t("moveFolder.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            press={() => {
              selectedFolder &&
                moveFolder({
                  folder,
                  // @ts-ignore
                  from: document.parentUuid,
                  to: selectedFolder.uuid,
                });
            }}
          >
            {t("moveFolder.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { MoveFolder };
